import { render } from "./GratulaciaOznamenie.vue?vue&type=template&id=6f5d1d40&scoped=true"
import script from "./GratulaciaOznamenie.vue?vue&type=script&lang=js"
export * from "./GratulaciaOznamenie.vue?vue&type=script&lang=js"

import "./GratulaciaOznamenie.vue?vue&type=style&index=0&id=6f5d1d40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5d1d40"]])

export default __exports__